import { injectRoxyTokens } from './utils/inject-tokens.js';
export * from './components/local-space-compass.js';
export { injectRoxyTokens, ROXY_UI_TOKENS_STYLE_ID } from './utils/inject-tokens.js';
injectRoxyTokens();
